import { logout } from '@/utils/auth';
import { putJson } from '@/utils/fetchOptions';

import { useMutation } from '@tanstack/react-query';
import { message } from 'antd/lib';
import { useTranslation } from 'react-i18next';
import { useAuthToken } from '..';
import { CloudinaryFile } from '../useUnifiedCloudinaryUpload';

interface UseScreenshotsReportProps {
  id: string;
  onSuccess: TypeAny;
}
export interface ScreenshotsReportType extends ResponseObject {
  request: Api.Influencer.Screenshot;
}

export function useScreenshotsReport({ id, onSuccess }: UseScreenshotsReportProps) {
  const token = useAuthToken();
  const { t } = useTranslation();

  const screenshotMutation = useMutation({
    mutationKey: ['influencer-screenshots-report', id],
    mutationFn: async (images: CloudinaryFile[]) => {
      return putJson({
        url: `${process.env.NEXT_PUBLIC_BEATLY_API_URL}/app/v2/influencer/screenshots/${id}/report`,
        body: { images },
        token
      }).then((response: ScreenshotsReportType) => {
        if ((response as ResponseExpiredToken).isExpired) {
          logout();
        }

        if (
          ['SCREENSHOTS_REPORTED', 'BEAT_FINISHED', 'COLLABORATION_FINISHED'].includes(
            response.code
          )
        ) {
          message.success(t(`alert.SAVED`));
        } else {
          message.error(t(`alert.${response.code}`));
        }
        return response;
      });
    },
    onSuccess
  });

  const screenshotReport = async (images: CloudinaryFile[]) => {
    await screenshotMutation.mutateAsync(images);
  };

  return {
    screenshotReport,
    isLoading: screenshotMutation.isLoading,
    error: screenshotMutation.error,
    isSuccess: screenshotMutation.isSuccess
  };
}
